module.exports = __webpack_public_path__ + "media/juntos.2aebb5ce.mp3";